import { useMediaQuery } from "../../public/smallScreen";

/**
 * Which reading of a page a screen gets, the one rule for every Season page: the phone, the iPad upright, the iPad on
 * its side with panes like Mail, or the computer, which keeps its own page. What React draws (a sheet or a pane) comes
 * from `useLayout`; what season.css lays out keys off `data-lay` on the page root, set from the same hook.
 */
export type Layout = "phone" | "upright" | "side" | "computer";
/** The three layouts a Season page is drawn for. */
export type SeasonLayout = Exclude<Layout, "computer">;

export const PHONE_LAYOUT_QUERY = "(max-width: 699px)";
export const UPRIGHT_QUERY = "(min-width: 700px) and (max-width: 1023px)";
// Why the pointer: a mouse at this width is a computer window, which keeps the computer's page.
export const SIDE_QUERY = "(min-width: 1024px) and (max-width: 1399px) and (pointer: coarse)";

/** The layout for what the three queries say. */
export function layoutOf(isPhone: boolean, isUpright: boolean, isSide: boolean): Layout {
  if (isPhone) return "phone";
  if (isUpright) return "upright";
  return isSide ? "side" : "computer";
}

export function useLayout(): Layout {
  return layoutOf(useMediaQuery(PHONE_LAYOUT_QUERY), useMediaQuery(UPRIGHT_QUERY), useMediaQuery(SIDE_QUERY));
}
